
import Header from './layout/Header';
import Footer from './layout/Footer';
import Service from './../service';
import { useFormik } from 'formik';
import * as yup from 'yup';
import React, { useCallback, useEffect, useRef, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import toast, { Toaster } from 'react-hot-toast';
import MetaHelmet from './metaHelmet'; //Include metaHelmet
import { useNavigate } from 'react-router-dom';

const api = new Service();
const RECAPTCHA_SCRIPT_ID = 'google-recaptcha-v2-script';

const ContactUs = (props) => {

    const [config] = useState(props.config);
    const [loading, setLoading] = useState(false);
    const [recaptchaToken, setRecaptchaToken] = useState('');
    const [recaptchaError, setRecaptchaError] = useState('');
    const [recaptchaReady, setRecaptchaReady] = useState(false);
    const recaptchaWidgetId = useRef(null);
    const recaptchaContainerRef = useRef(null);
    const navigate = useNavigate();

    const resetRecaptcha = useCallback(() => {
        setRecaptchaToken('');
        if (window.grecaptcha && recaptchaWidgetId.current !== null) {
            try {
                window.grecaptcha.reset(recaptchaWidgetId.current);
            } catch (e) {
                // ignore reset errors
            }
        }
    }, []);

    const renderRecaptcha = useCallback(() => {
        if (!config.RECAPTCHA_SITE_KEY || !window.grecaptcha || !recaptchaContainerRef.current) {
            return;
        }
        if (recaptchaWidgetId.current !== null) {
            return;
        }
        recaptchaWidgetId.current = window.grecaptcha.render(recaptchaContainerRef.current, {
            sitekey: config.RECAPTCHA_SITE_KEY,
            callback: (token) => {
                setRecaptchaToken(token || '');
                setRecaptchaError('');
            },
            'expired-callback': () => {
                setRecaptchaToken('');
            },
        });
        setRecaptchaReady(true);
    }, [config.RECAPTCHA_SITE_KEY]);

    useEffect(() => {
        if (!config.RECAPTCHA_SITE_KEY) {
            return;
        }

        const existing = document.getElementById(RECAPTCHA_SCRIPT_ID);

        window.__moveitRecaptchaOnLoad = () => {
            if (window.grecaptcha) {
                window.grecaptcha.ready(renderRecaptcha);
            }
        };

        if (window.grecaptcha) {
            window.grecaptcha.ready(renderRecaptcha);
            return () => {
                delete window.__moveitRecaptchaOnLoad;
            };
        }

        if (!existing) {
            const script = document.createElement('script');
            script.id = RECAPTCHA_SCRIPT_ID;
            script.src = 'https://www.google.com/recaptcha/api.js?onload=__moveitRecaptchaOnLoad&render=explicit';
            script.async = true;
            script.defer = true;
            document.body.appendChild(script);
        }

        return () => {
            delete window.__moveitRecaptchaOnLoad;
        };
    }, [config.RECAPTCHA_SITE_KEY, renderRecaptcha]);

    const Formik = useFormik({
        initialValues: {
            name: '',
            email_id: '',
            message: '',
        },
        validationSchema: yup.object({
            name: yup.string().required('Please enter your name'),
            email_id: yup.string().email('Invalid email address').required('Please enter your email address'),
            message: yup.string().required('Please enter your message.'),
        }),

        onSubmit: values => {
            if (!recaptchaToken) {
                setRecaptchaError(config.RECAPTCHA_SITE_KEY
                    ? 'Please complete the captcha.'
                    : 'Captcha is not configured.');
                return;
            }
            setRecaptchaError('');
            setLoading(true)
            api.postApi('contact-us', { ...values, recaptcha_token: recaptchaToken }).then(response => {
                if (response) {
                    toast.success('Thank you for contacting us. We will respond ASAP.');
                    setLoading(false)
                    navigate('/thankyou');
                }
                Formik.resetForm()
                resetRecaptcha();
                setLoading(false)
            }).catch(error => {
                setLoading(false)
                resetRecaptcha();
                toast.error(error.message);
            });
        }

    });

    const [metaDetail, setMetaDetail] = useState({});


    const GetMetaDetail = () => {
        api.getApi('getMetaByPageName', { page_name: '/contact-us' }).then(response => {
            console.log(response, 'responseName')
            if (response && response.record) {
                console.log(response, 'getting response');
                setMetaDetail(response.record)

            }

        }).catch(error => {
            toast.error(error.message);
        });
    }

    useEffect(() => {
        GetMetaDetail();
    }, []);

    useEffect(() => {
        document.title = metaDetail.meta_title;
        window.gtag('config', config.G_TAG, {
            page_title: metaDetail.meta_title,
            page_path: window.location.pathname,
        });
    }, [metaDetail]);

    return (
        <>
            {metaDetail ?
                <MetaHelmet title={metaDetail.meta_title} description={metaDetail.meta_description} />
                : ''}
            {/* <MetaHelmet title="Contact Us - Move It" description="If you need help with anything or have questions / concerns please don't hesitate to ask. You can send us a message and also send an email." /> */}
            <Toaster position="top-right" reverseOrder={false} />
            <Header></Header>
            <main>
                <section className="hero clean bg-pod conus-img" style={{ backgroundImage: `url("web/img/c-us.jpg")` }}>
                    <article>
                        <div className="grid">
                            <div className="unit-2-3 unit-1-1-md">
                                <h1 className="h2 f-46">Contact Us</h1>
                                <h2 className="h5 mb-2">How can we help you?</h2>
                            </div>
                        </div>
                    </article>
                </section>


                <section className="slate">
                    <article>
                        <div className="grid grid-lg">
                            <div className="col-md-12 mb-5">
                                <h5>Our goal at Move It is to provide 100% customer satisfaction. If you need help with anything or have questions / concerns please don't hesitate to ask.</h5>
                            </div>

                            <div id="contact" className="unit-3-5 unit-1-1-md margin-bottom">
                                <form onSubmit={Formik.handleSubmit}>

                                    <label>
                                        <span>Name*</span>
                                        <input type="text" name="name" {...Formik.getFieldProps("name")} placeholder="Enter your name..." />
                                        {Formik.touched.name && Formik.errors.name ? <span className="text-danger">{Formik.errors.name}</span> : null}
                                    </label>

                                    <label>
                                        <span>Email Address*</span>
                                        <input type="email" name="email_id" {...Formik.getFieldProps("email_id")} placeholder="Enter your email address..." />
                                        {Formik.touched.email_id && Formik.errors.email_id ? <span className="text-danger">{Formik.errors.email_id}</span> : null}
                                    </label>

                                    <label>
                                        <span>Tell Us how we are doing</span>
                                        <textarea rows="5" name="message" {...Formik.getFieldProps("message")} placeholder="Enter your message..."></textarea>
                                        {Formik.touched.message && Formik.errors.message ? <span className="text-danger">{Formik.errors.message}</span> : null}
                                    </label>

                                    <div className="mb-3">
                                        {config.RECAPTCHA_SITE_KEY ? (
                                            <div ref={recaptchaContainerRef} className="g-recaptcha" />
                                        ) : (
                                            <span className="text-danger">Captcha is not configured.</span>
                                        )}
                                        {config.RECAPTCHA_SITE_KEY && !recaptchaReady ? (
                                            <span className="d-block text-muted mt-1">Loading captcha...</span>
                                        ) : null}
                                        {recaptchaError ? <span className="text-danger d-block mt-1">{recaptchaError}</span> : null}
                                    </div>

                                    <div className="">
                                        <button className="full" type="submit" disabled={loading}><span>{loading ? 'Sending...' : 'Send Message'}</span></button>
                                    </div>
                                </form>
                            </div>
                            <div className="unit-2-5 unit-1-1-md margin-bottom">
                                <div className="content-box pattern flourish right contact-right">
                                    <span className="flourish-square"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150" width="150" height="150" preserveAspectRatio="xMidYMid meet" style={{ width: "100%", height: "100%", transform: "translate3d(0px, 0px, 0px)" }}><defs><clipPath id="__lottie_element_3"><rect width="150" height="150" x="0" y="0"></rect></clipPath></defs><g clipPath="url(#__lottie_element_3)"><g style={{ display: "block" }} transform="matrix(1,0,0,1,459,133.5)" opacity="1"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path strokeLinecap="butt" strokeLinejoin="miter" fillOpacity="0" strokeMiterlimit="4" stroke="rgb(232,154,167)" strokeOpacity="1" strokeWidth="10" d=" M-317,-65 C-317,-65 -317,-125 -317,-125 C-317,-125 -451,-125 -451,-125 C-451,-125 -451,8 -451,8 C-451,8 -394,8 -394,8"></path></g></g></g></svg></span>
                                    <h3>Customer Support</h3>

                                    <p>Email:<a href="mailto:support@gomoveit.com" target="_blank" rel="noreferrer"> support@gomoveit.com</a></p>
                                    <p>Question about becoming a Move It Pro or Muscle:<a href="mailto:helpers@gomoveit.com" target="_blank" rel="noreferrer"> helpers@gomoveit.com</a></p>
                                    <p>Interested in partnering with Move It for your business?<a href="mailto:partners@gomoveit.com" target="_blank" rel="noreferrer"> partners@gomoveit.com</a></p>

                                </div>
                            </div>
                        </div>
                    </article>
                </section>

            </main>

            <Footer loading={loading}></Footer>
        </>
    );
}

export default ContactUs;
